import useGetShowBanners from './useGetShowBanners';
import useGetWipStatusBannerComponent from './WIPStatusBanner';

export default function Banners() {
  const { isBannerShowing, showWIPBanner } = useGetShowBanners();
  const StatusBannerComponent = useGetWipStatusBannerComponent();

  if (!isBannerShowing) return null;

  if (showWIPBanner) {
    return StatusBannerComponent;
  }

  return null;
}
